module.exports = __webpack_public_path__ + "static/media/ehealth_minor_reg_banner_desktop.3ba934b8.jpg";